export enum UserTags{
  GPS = "GPS",
  MOBILE_ALARM_DEVICE = "MOBILE_ALARM_DEVICE",
  COLLEAGUE_ALERT = "COLLEAGUE_ALERT",
  OTHER = "OTHER",
  NONE = "NONE"
}